import http from "@/services/http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async list() {
        return await http.get(buildUrlFromLocation(`/admin/applications-import-export`, { campaignId: null }));
    },
    async startExport(applicationLinkId) {
        return await http.get(buildUrlFromLocation(`/admin/applications-import-export/${applicationLinkId}/execute`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/applicationLink.js